import { keyframes, jsx } from '@emotion/react';
import { labelStyles } from '@zapier/style-encapsulation';
import { ColorsCSS } from '../../../../theme/Colors.es.js';
import '../../../../theme/Shadows.es.js';
import '../../../../theme/Typography.es.js';
import '../../../../theme/ZinniaStylesReset.es.js';

const streakAnimation = keyframes({
  "0%": {
    transform: "translateX(-100%)"
  },
  "100%": {
    transform: "translateX(100%)"
  }
});
const Styles = labelStyles("SkeletonBlock", {
  root: (color) => [
    {
      backgroundColor: ColorsCSS[color],
      overflow: "hidden",
      position: "relative",
      "&::before": {
        animation: `${streakAnimation} 1s ease-in-out infinite`,
        content: '""',
        background: `linear-gradient(90deg, rgba(255, 255, 255, 0), rgba(255, 255, 255, 0.3), rgba(255, 255, 255, 0))`,
        position: "absolute",
        top: "0",
        right: "0",
        bottom: "0",
        left: "0"
      }
    }
  ]
});
const SkeletonBlock = ({ aspectRatio = void 0, borderRadius = 5, height = void 0, width = "100%", color = "neutral200" }) => {
  const style = {
    borderRadius,
    width,
    paddingTop: aspectRatio ? `calc(${width} / ${aspectRatio})` : height
  };
  return jsx("div", { css: Styles.root(color), "data-testid": "SkeletonBlock", "data-zds": true, style });
};

export { SkeletonBlock };
//# sourceMappingURL=SkeletonBlock.es.js.map
